import { rest } from 'msw'

export default [
  /**
   * 施設情報
   */
  rest.get('/swc-api/master/sites', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json([
        {
            "id": 1,
            "name": "蔵王工場",
            "address": "宮城県刈田郡蔵王町大字円田字西浦北10",
            "site_code": "zao",
            "specification": null,
            "construction_memo": null,
            "image": null,
            "organization_code": "2",
            "organization_name": "C 社",
            "pf_area_id": null,
            "prefectures_code": "04",
            "prefectures_name": "宮城県",
            "plant_list": [
                {
                    "id": 7,
                    "name": "用水処理",
                    "specification": null,
                    "construction_memo": null,
                    "image": null,
                    "organization_code": "2",
                    "organization_name": "C 社",
                    "industry_type_code": "aqueduct",
                    "industry_type_name": "用水処理",
                    "site_id": 1,
                    "site_name": "蔵王工場",
                    "node_list": [
                        {
                            "id": 9,
                            "name": "排水処理 SaiForce",
                            "image": "",
                            "specification": null,
                            "construction_memo": null,
                            "organization_code": "2",
                            "organization_name": "C 社",
                            "facility_group_code": "SaiForce",
                            "facility_group_name": "SaiForce",
                            "plant_id": 7,
                            "plant_name": "用水処理",
                            "dashboard_settings": null,
                            "site_id": 1,
                            "site_name": "蔵王工場"
                        }
                    ]
                },
                {
                    "id": 1,
                    "name": "排水処理",
                    "specification": null,
                    "construction_memo": null,
                    "image": null,
                    "organization_code": "2",
                    "organization_name": "C 社",
                    "industry_type_code": "drainage",
                    "industry_type_name": "排水処理",
                    "site_id": 1,
                    "site_name": "蔵王工場",
                    "node_list": [
                        {
                            "id": 1,
                            "name": "排水処理 MBR",
                            "image": "",
                            "specification": null,
                            "construction_memo": null,
                            "organization_code": "2",
                            "organization_name": "C 社",
                            "facility_group_code": "MBR",
                            "facility_group_name": "MBR",
                            "plant_id": 1,
                            "plant_name": "排水処理",
                            "dashboard_settings": null,
                            "site_id": 1,
                            "site_name": "蔵王工場"
                        }
                    ]
                }
            ]
        },
        {
            "id": 2,
            "name": "S 浄化センター",
            "address": "島根県松江市末次町86番地",
            "site_code": "shimanejouka",
            "specification": null,
            "construction_memo": null,
            "image": null,
            "organization_code": "4",
            "organization_name": "島根県水道局",
            "pf_area_id": 5,
            "pf_area_name": "近畿",
            "prefectures_code": "32",
            "prefectures_name": "島根県",
            "plant_list": [
                {
                    "id": 2,
                    "name": "移動脱水車",
                    "specification": null,
                    "construction_memo": null,
                    "image": null,
                    "organization_code": "4",
                    "organization_name": "島根県水道局",
                    "industry_type_code": "mobile_dehydration",
                    "industry_type_name": "移動脱水車",
                    "site_id": 2,
                    "site_name": "S 浄化センター",
                    "node_list": [
                        {
                            "id": 4,
                            "name": "移動脱水車 3 系統",
                            "image": "",
                            "specification": null,
                            "construction_memo": null,
                            "organization_code": "4",
                            "organization_name": "島根県水道局",
                            "facility_group_code": null,
                            "plant_id": 2,
                            "plant_name": "移動脱水車",
                            "dashboard_settings": null,
                            "site_id": 2,
                            "site_name": "S 浄化センター"
                        },
                        {
                            "id": 3,
                            "name": "移動脱水車 2 系統",
                            "image": "",
                            "specification": null,
                            "construction_memo": null,
                            "organization_code": "4",
                            "organization_name": "島根県水道局",
                            "facility_group_code": null,
                            "plant_id": 2,
                            "plant_name": "移動脱水車",
                            "dashboard_settings": null,
                            "site_id": 2,
                            "site_name": "S 浄化センター"
                        },
                        {
                            "id": 2,
                            "name": "移動脱水車 1 系統",
                            "image": "",
                            "specification": null,
                            "construction_memo": null,
                            "organization_code": "4",
                            "organization_name": "島根県水道局",
                            "facility_group_code": null,
                            "plant_id": 2,
                            "plant_name": "移動脱水車",
                            "dashboard_settings": null,
                            "site_id": 2,
                            "site_name": "S 浄化センター"
                        }
                    ]
                }
            ]
        },
        {
            "id": 3,
            "name": "TK 大学",
            "address": "東京都八王子市元本郷町三丁目24番1号",
            "site_code": "tkdaigaku",
            "specification": null,
            "construction_memo": null,
            "image": null,
            "organization_code": "5",
            "organization_name": "TK 大学",
            "pf_area_id": null,
            "prefectures_code": "13",
            "prefectures_name": "東京都",
            "plant_list": [
                {
                    "id": 3,
                    "name": "排水処理",
                    "specification": null,
                    "construction_memo": null,
                    "image": null,
                    "organization_code": "5",
                    "organization_name": "TK 大学",
                    "industry_type_code": "drainage",
                    "industry_type_name": "排水処理",
                    "site_id": 3,
                    "site_name": "TK 大学",
                    "node_list": [
                        {
                            "id": 5,
                            "name": "排水処理",
                            "image": "",
                            "specification": null,
                            "construction_memo": null,
                            "organization_code": "5",
                            "organization_name": "TK 大学",
                            "facility_group_code": null,
                            "plant_id": 3,
                            "plant_name": "排水処理",
                            "dashboard_settings": null,
                            "site_id": 3,
                            "site_name": "TK 大学"
                        }
                    ]
                }
            ]
        },
        {
            "id": 4,
            "name": "名古屋工場",
            "address": "愛知県名古屋市中区三の丸三丁目1番1号",
            "site_code": "nagoya",
            "specification": null,
            "construction_memo": null,
            "image": null,
            "organization_code": "6",
            "organization_name": "A 社",
            "pf_area_id": null,
            "prefectures_code": "23",
            "prefectures_name": "愛知県",
            "plant_list": [
                {
                    "id": 4,
                    "name": "用水処理",
                    "specification": null,
                    "construction_memo": null,
                    "image": null,
                    "organization_code": "6",
                    "organization_name": "A 社",
                    "industry_type_code": "aqueduct",
                    "industry_type_name": "用水処理",
                    "site_id": 4,
                    "site_name": "名古屋工場",
                    "node_list": [
                        {
                            "id": 6,
                            "name": "用水処理処理 RO",
                            "image": "",
                            "specification": null,
                            "construction_memo": null,
                            "organization_code": "6",
                            "organization_name": "A 社",
                            "facility_group_code": "RO",
                            "facility_group_name": "RO",
                            "plant_id": 4,
                            "plant_name": "用水処理",
                            "dashboard_settings": null,
                            "site_id": 4,
                            "site_name": "名古屋工場"
                        }
                    ]
                }
            ]
        },
        {
            "id": 5,
            "name": "宇治川工場",
            "address": "京都府宇治市宇治琵琶33番地山梨県北杜市白州町鳥原2913-1",
            "site_code": "uji",
            "specification": null,
            "construction_memo": null,
            "image": null,
            "organization_code": "3",
            "organization_name": "S 社",
            "pf_area_id": null,
            "prefectures_code": "26",
            "prefectures_name": "京都府",
            "plant_list": [
                {
                    "id": 5,
                    "name": "用水処理",
                    "specification": null,
                    "construction_memo": null,
                    "image": null,
                    "organization_code": "3",
                    "organization_name": "S 社",
                    "industry_type_code": "aqueduct",
                    "industry_type_name": "用水処理",
                    "site_id": 5,
                    "site_name": "宇治川工場",
                    "node_list": [
                        {
                            "id": 7,
                            "name": "用水処理 SaiForce",
                            "image": "",
                            "specification": null,
                            "construction_memo": null,
                            "organization_code": "3",
                            "organization_name": "S 社",
                            "facility_group_code": "SaiForce",
                            "facility_group_name": "SaiForce",
                            "plant_id": 5,
                            "plant_name": "用水処理",
                            "dashboard_settings": null,
                            "site_id": 5,
                            "site_name": "宇治川工場"
                        }
                    ]
                }
            ]
        },
        {
            "id": 6,
            "name": "多摩川工場",
            "address": "東京都稲城市東長沼2111番地",
            "site_code": "tamagawa",
            "specification": null,
            "construction_memo": null,
            "image": null,
            "organization_code": "3",
            "organization_name": "S 社",
            "pf_area_id": null,
            "prefectures_code": "13",
            "prefectures_name": "東京都",
            "plant_list": [
                {
                    "id": 6,
                    "name": "用水処理",
                    "specification": null,
                    "construction_memo": null,
                    "image": null,
                    "organization_code": "3",
                    "organization_name": "S 社",
                    "industry_type_code": "aqueduct",
                    "industry_type_name": "用水処理",
                    "site_id": 6,
                    "site_name": "多摩川工場",
                    "node_list": [
                        {
                            "id": 8,
                            "name": "用水処理 SaiForce",
                            "image": "",
                            "specification": null,
                            "construction_memo": null,
                            "organization_code": "3",
                            "organization_name": "S 社",
                            "facility_group_code": "SaiForce",
                            "facility_group_name": "SaiForce",
                            "plant_id": 6,
                            "plant_name": "用水処理",
                            "dashboard_settings": null,
                            "site_id": 6,
                            "site_name": "多摩川工場"
                        }
                    ]
                }
            ]
        },
        {
            "id": 7,
            "name": "群馬工場",
            "address": "群馬県伊勢崎市今泉町二丁目410番地",
            "site_code": "gunma",
            "specification": null,
            "construction_memo": null,
            "image": null,
            "organization_code": "7",
            "organization_name": "P 社",
            "pf_area_id": null,
            "prefectures_code": "10",
            "prefectures_name": "群馬県",
            "plant_list": [
                {
                    "id": 8,
                    "name": "排水処理",
                    "specification": null,
                    "construction_memo": null,
                    "image": null,
                    "organization_code": "7",
                    "organization_name": "P 社",
                    "industry_type_code": "drainage",
                    "industry_type_name": "排水処理",
                    "site_id": 7,
                    "site_name": "群馬工場",
                    "node_list": [
                        {
                            "id": 10,
                            "name": "排水処理 MBR",
                            "image": "",
                            "specification": null,
                            "construction_memo": null,
                            "organization_code": "7",
                            "organization_name": "P 社",
                            "facility_group_code": "MBR",
                            "facility_group_name": "MBR",
                            "plant_id": 8,
                            "plant_name": "排水処理",
                            "dashboard_settings": null,
                            "site_id": 7,
                            "site_name": "群馬工場"
                        }
                    ]
                }
            ]
        }
    ]
    ),
    )
  }),
  /**
   * 施設詳細情報
   */
  rest.get('/swc-api/master/sites/:site_id', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json({
        "id": 1,
        "name": "蔵王工場",
        "address": "宮城県刈田郡蔵王町大字円田字西浦北10",
        "site_code": "zao",
        "specification": null,
        "construction_memo": null,
        "image": null,
        "organization_code": "2",
        "organization_name": "C 社",
        "pf_area_id": null,
        "prefectures_code": "04",
        "prefectures_name": "宮城県",
        "plant_list": [
            {
                "id": 7,
                "name": "用水処理",
                "specification": null,
                "construction_memo": null,
                "image": null,
                "organization_code": "2",
                "organization_name": "C 社",
                "industry_type_code": "aqueduct",
                "industry_type_name": "用水処理",
                "site_id": 1,
                "site_name": "蔵王工場",
                "node_list": [
                    {
                        "id": 9,
                        "name": "排水処理 SaiForce",
                        "image": "",
                        "specification": null,
                        "construction_memo": null,
                        "organization_code": "2",
                        "organization_name": "C 社",
                        "facility_group_code": "SaiForce",
                        "facility_group_name": "SaiForce",
                        "plant_id": 7,
                        "plant_name": "用水処理",
                        "dashboard_settings": null,
                        "site_id": 1,
                        "site_name": "蔵王工場"
                    }
                ]
            },
            {
                "id": 1,
                "name": "排水処理",
                "specification": null,
                "construction_memo": null,
                "image": null,
                "organization_code": "2",
                "organization_name": "C 社",
                "industry_type_code": "drainage",
                "industry_type_name": "排水処理",
                "site_id": 1,
                "site_name": "蔵王工場",
                "node_list": [
                    {
                        "id": 1,
                        "name": "排水処理 MBR",
                        "image": "",
                        "specification": null,
                        "construction_memo": null,
                        "organization_code": "2",
                        "organization_name": "C 社",
                        "facility_group_code": "MBR",
                        "facility_group_name": "MBR",
                        "plant_id": 1,
                        "plant_name": "排水処理",
                        "dashboard_settings": null,
                        "site_id": 1,
                        "site_name": "蔵王工場"
                    }
                ]
            }
        ]
    }),
    )
  }),
  /**
   * 施設情報新規登録
   */
  rest.post('/swc-api/master/sites', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json([])
    )
  }),
  /**
   * 施設情報更新
   */
  rest.put('/swc-api/master/sites/:site_id', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json([])
    )
  }),
  /**
   * 施設情報削除
   */
  rest.delete('/swc-api/master/sites/:site_id', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json([])
    )
  }),
]
